/** Presentation formatting helpers for the dashboard (no Angular DI; safe to unit-test directly). */

const CURRENCY = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

const INTEGER = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

/** e.g. 48250.75 -> "$48,250.75" */
export function currency(value: number): string {
  return CURRENCY.format(value ?? 0);
}

/** e.g. 1320 -> "1,320" */
export function integer(value: number): string {
  return INTEGER.format(value ?? 0);
}

/** e.g. 0.625 -> "63%" (ratio in 0..1) */
export function percent(ratio: number, fractionDigits = 0): string {
  return `${((ratio ?? 0) * 100).toFixed(fractionDigits)}%`;
}
